import {SUB_TYPES} from "../constants/preset-constants";

export const getProfileSubTypeFromBioMake = (make: string): string => {
    switch (make) {
        case 'Sagem':
        case 'Morpho':
        case 'Idemia':
            return SUB_TYPES.IDEMIA;
        case 'Control iD':
            return SUB_TYPES.CONTROL_ID;
        case 'HIK Vision':
            return SUB_TYPES.HIK_VISION;
        case 'HID Amico':
            return SUB_TYPES.HID_AMICO;
        default:
            return '0';
    }
}
